import { render, staticRenderFns } from "./EditCard.vue?vue&type=template&id=2c491c88&"
import script from "./EditCard.ts?vue&type=script&lang=js&"
export * from "./EditCard.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports